import React, { useEffect, useState } from 'react';
import MedibuddyLogo from '../assets/homepage/mb_logo.svg';
import 'font-awesome/css/font-awesome.min.css';
import Grid from '@material-ui/core/Grid';
import '../assets/css/header.css'
import useDataStore from '../store/dataStore';


function Header(props) {
    const [source, setSource] = useState("")
    const data = useDataStore((state) => state.data);
    useEffect(() => {
        setSource(localStorage.getItem("source"))
    })
    return (
        <div className="header" style={{}}>
            <Grid container spacing={0} alignItems="center" justifyContent="space-between">
                <Grid item xs={6} sm={6} md={6} lg={6}>
                    <Grid container spacing={0} alignItems="center">
                        <Grid item xs={12}>
                            <div className="mbLogo">
                                <a href={getHomepage()}>
                                    <img src={MedibuddyLogo} alt="" />
                                </a>
                            </div>

                        </Grid>
                    </Grid>
                </Grid>
                 <Grid item xs={6} sm={6} md={6} lg={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {(data && data.logo) && (
                        <div className="genericLogo" style ={props.style}>
                            <img src={data.logo} style={{ width: `min(calc(${data.logoAspectRatio || 1}*${data.logoAspectRatio ? 68 : 100}px),100%)`, height: `${data.logoAspectRatio ? 68 : 80}px`, objectFit: 'contain', marginRight:'16px' }} />
                        </div>
                    )}
                </Grid>



            </Grid>
        </div>
    )

}
function getHomepage() {
    return ('/home?utm_source=' + localStorage.getItem("source"))
}

export default Header
